module.exports = __webpack_public_path__ + "static/Laptop1_MobileES-7645ce237b01d93ca61206a2c3156d28.mp4";